import { render, staticRenderFns } from "./core-top-users-chart.vue?vue&type=template&id=03fd9738&scoped=true"
import script from "./core-top-users-chart.vue?vue&type=script&lang=js"
export * from "./core-top-users-chart.vue?vue&type=script&lang=js"
import style0 from "./core-top-users-chart.vue?vue&type=style&index=0&id=03fd9738&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03fd9738",
  null
  
)

export default component.exports